/**
 * The word game's page codes: what /words/<code> carries (ask #60, Tom/Aran, ruling
 * r-2026-10-10-language-codes-everywhere-routes-keys-urls: language codes in URLs are three letters,
 * ISO 639-3). A language's `code` (languages/index.ts) stays its short internal id and lang tag; the
 * URL is the three-letter one, which for every non-edition language is also its stored `key`
 * (languages.test.ts holds the two together). The English editions are already eng-<known> (job #877).
 *
 * Kept free of imports so the router guard and celtic.ts can read it without loading the registry.
 * The two-letter codes the game first shipped with stay working: the guard redirects them here.
 */
export const PAGE_CODE: Readonly<Record<string, string>> = {
  cy: 'cym',
  es: 'spa',
  de: 'deu',
  it: 'ita',
  fr: 'fra',
  pt: 'por',
  nl: 'nld',
  el: 'ell',
  ga: 'gle',
  gd: 'gla',
  kw: 'cor',
  gv: 'glv',
  br: 'bre',
}

/** A language's URL code from its internal code: the three-letter one, or the code itself (the editions). */
export function pageCode(code: string): string {
  return PAGE_CODE[code] ?? code
}

/** The page for a language by its internal code, and for a friend's invite to it. */
export function wordsPath(code: string, inviteToken?: string): string {
  const c = pageCode(code)
  return inviteToken ? `/words/${c}/join/${inviteToken}` : `/words/${c}`
}

/** The three-letter code an old two-letter /words/<code> link now lives at, or null. */
export function legacyPageCode(code: unknown): string | null {
  return typeof code === 'string' && Object.prototype.hasOwnProperty.call(PAGE_CODE, code) ? PAGE_CODE[code] : null
}
